interface Console {
    enableLog(): void,
    disableLog(): void,
    setEnable(value: boolean): void
}

const consoleProto = Object.getPrototypeOf(console);
const originLog = console.log;

consoleProto.enableLog = function(): void {
    this.log = originLog;
}

consoleProto.disableLog = function(): void {
    this.log = new Function();
}

consoleProto.setEnable = function(value: boolean): void {
    if (value) {
        this.enableLog();
    } else {
        this.disableLog();
    }
}
